.card {
  background-color: var(--pgm-sys-color-surface-container-low);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-2);
  padding: var(--pgm-sys-spacing-8) var(--pgm-sys-spacing-10);
}

.title {
  color: var(--pgm-sys-color-on-surface);
  margin: 0;
}

.subtitle {
  color: var(--pgm-sys-color-on-surface-variant);
  margin: 0;
}

@media (max-width: 599.98px) {
  .card {
    padding: var(--pgm-sys-spacing-6);
  }
}
